import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';
import { UserConsumer } from '../core/providers/UserProvider';
import { checkEntitlements, isModuleActivated } from '../core/utils/utils';

function PrivateRoute({ component: Component, entitlement, loadKey, modules, requiredModule, ...rest }) {

    return (
        <UserConsumer>
            {({ user, entitlements }) => (
                <Route render={props => {

                    if (!user) {
                        // Not logged in so redirect to login page with the return url
                        return <Redirect to={{ pathname: '/login' }} />;
                    }

                    if (requiredModule && (!modules || modules === undefined || !isModuleActivated(modules, requiredModule))) {
                        // No access to a module
                        return <Redirect to={{ pathname: '/login' }} />;
                    }

                    // Check if route is restricted by entitlement
                    // Expecting only one entitlement at the moment
                    let entitled = false;
                    if (!entitlement) {
                        // No entitlement requirements so all allowed
                        entitled = true;
                    }
                    else {
                        if (entitlements) {
                            entitled = checkEntitlements(entitlements, entitlement);
                        }
                        // Else no entitlements so not allowed
                    }
                    if (!entitled) return <Redirect to={{ pathname: '/' }} />;
                    // We pass key as loadKey to force a remount if necessary on passed component
                    const keyToUse = loadKey || "PR";
                    return <Component
                        key={keyToUse}
                        modules={modules}
                        loadKey={loadKey}
                        {...rest}
                        {...props} />;
                }} />
            )}
        </UserConsumer>
    );
}

PrivateRoute.propTypes = {
    entitlement: PropTypes.array,
    loadKey: PropTypes.string,
    modules: PropTypes.number,
    requiredModule: PropTypes.number
};

export default PrivateRoute;